import { CategoriesApi, useAPIQuery } from "melco-shared-logic";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";

export const useGetCategories = () => {
  const { data } = useAPIQuery(
    CategoriesApi,
    ["getcategories"],
    async (api) => {
      let response = await api.categoriesSearch({
        publishState: ALL_PUBLISHED_STATES,
      });

      return response;
    }
  );

  return {
    data: data?.list ?? [],
    total: data?.total ?? 0,
    warning_list: data?.warning_list ?? [],
  };
};
